export const getVirtualFocusGroupData = (state, sessionId, questionJoinerId) => {
  return state.virtualFocusGroupStore[`${sessionId}-${questionJoinerId}`];
};
